const swiper = new Swiper(".mv_slide .swiper", {
  loop: true,
  speed: 1500,
  centeredSlides: true,
  spaceBetween: 30,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  slidesPerView: 1,
  spaceBetween: 10,

  breakpoints: {
    920: {
      slidesPerView: 1.825,
      spaceBetween: 50,
      centeredSlides: true,
    },
  },
});
